
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M22 10V2C22 1.45 21.55 1 21 1H15C14.45 1 14 1.45 14 2V10C14 11.86 15.28 13.41 17 13.86V21H16C15.45 21 15 21.45 15 22C15 22.55 15.45 23 16 23H20C20.55 23 21 22.55 21 22C21 21.45 20.55 21 20 21H19V13.86C20.72 13.41 22 11.86 22 10ZM20 3V6H16V3H20ZM9.86005 9H8.00005V8H9.86005C11.17 8 12.36 7.06 12.49 5.76C12.64 4.26 11.47 3 10 3H8.00005V2C8.00005 1.45 7.55005 1 7.00005 1C6.45005 1 6.00005 1.45 6.00005 2V3H4.14005C2.83005 3 1.64005 3.94 1.51005 5.24C1.36005 6.74 2.53005 8 4.00005 8H6.00005V9H4.14005C2.83005 9 1.64005 9.94 1.51005 11.24C1.36005 12.74 2.53005 14 4.00005 14H6.00005V22C6.00005 22.55 6.45005 23 7.00005 23C7.55005 23 8.00005 22.55 8.00005 22V14H10C11.47 14 12.64 12.74 12.49 11.24C12.36 9.94 11.17 9 9.86005 9Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-tapas`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTapas

    ```js
    <b-new-b-icon-tapas />
    ```
</docs>


